import React, { ChangeEvent } from 'react';
import { Link } from 'react-router-dom';
import { Add as AddIcon, Email as EmailIcon } from '@mui/icons-material';
import SearchBar from '../../../Common/Components/Controls/SearchBar';
import CustomButton from '../../../Common/Components/Controls/InputControls';
import HeaderToolbar from '../../../Common/Components/HeaderToolbar';

const EmailAdminToolbar = (props: {
  onFilterRequest: (event: ChangeEvent<HTMLInputElement>) => void;
}) => {
  return (
    <HeaderToolbar
      leftContent={<SearchBar onChange={props.onFilterRequest} width="35%" />}
      rightContent={
        <>
          <CustomButton
            component={Link}
            to={'emailadministration/sendemail'}
            startIcon={<EmailIcon />}
            label="Send Email"
          />
          <CustomButton
            component={Link}
            to={'emailadministration/emailtemplate/create'}
            startIcon={<AddIcon />}
            label="Add"
          />
        </>
      }
    />
  );
};

export default EmailAdminToolbar;
